import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const TopupSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
    const navigate = useNavigate();
    const userId = localStorage.getItem("urlID")

  useEffect(() => {
    if (sessionId) {
      // Optional: hit backend to confirm session & maybe show details
      axios
        .get(`/api/stripe/session-status/${sessionId}`)
        .then((res) => {
          console.log("✅ Session verified:", res.data);
        })
        .catch((err) => {
          console.error("❌ Session verification failed:", err.message);
        });
    }
  }, [sessionId]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>🎉 Top-up Successful!</h2>
      <p>Thank you for adding funds to your wallet.</p>
      {sessionId && <p>Session ID: {sessionId}</p>}
      <Button onClick={() => navigate(`/VesselOwnerLayouts/${userId}/wallet`)}>Go to Wallet</Button>
    </div>
  );
};

export default TopupSuccessPage;
